import { initialState } from "./State";
import { DuplicateDebtors } from "us.collection.debtor/constants/Actions";
import {
  handleDebtorSelection,
  selectRetainingDebtor,
} from "us.collection.debtor/functions";
import { getChildDebtorHistory } from "./Functions";

const {
  SEARCH_DUPLICATING_DEBTORS,
  SEARCH_DUPLICATING_DEBTORS_SUCCESS,
  SEARCH_DUPLICATING_DEBTORS_FAIL,
  SELECT_DUPLICATE_DEBTORS,
  CHANGE_RETAINING_DEBTOR,
  MERGE_DUPLICATE_DEBTORS,
  MERGE_DUPLICATE_DEBTORS_SUCCESS,
  MERGE_DUPLICATE_DEBTORS_FAIL,
  GET_DUPLICATE_DEBTORS_HISTORY,
  GET_DUPLICATE_DEBTORS_HISTORY_SUCCESS,
  GET_DUPLICATE_DEBTORS_HISTORY_FAIL,
} = DuplicateDebtors;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case SEARCH_DUPLICATING_DEBTORS:
      return Object.assign({}, state, {
        duplicatingDebtors: {
          ...state.duplicatingDebtors,
          isLoading: true,
        },
      });
    case SEARCH_DUPLICATING_DEBTORS_SUCCESS:
      return Object.assign({}, state, {
        duplicatingDebtors: {
          isLoading: false,
          data: payload.data,
        },
      });
    case SEARCH_DUPLICATING_DEBTORS_FAIL:
      return Object.assign({}, state, {
        duplicatingDebtors: {
          isLoading: false,
          data: state.duplicatingDebtors.data,
        },
      });
    case SELECT_DUPLICATE_DEBTORS:
      return Object.assign({}, state, {
        selectedDebtors: handleDebtorSelection(
          payload.data,
          state.selectedDebtors
        ),
      });
    case CHANGE_RETAINING_DEBTOR:
      return Object.assign({}, state, {
        duplicatingDebtors: {
          ...state.duplicatingDebtors,
          data: selectRetainingDebtor(
            payload.data,
            state.duplicatingDebtors.data
          ),
        },
        selectedDebtors: [],
      });
    case MERGE_DUPLICATE_DEBTORS:
      return Object.assign({}, state, {
        isDebtorMergeSaving: true,
      });
    case MERGE_DUPLICATE_DEBTORS_SUCCESS:
      return Object.assign({}, state, {
        isDebtorMergeSaving: false,
      });
    case MERGE_DUPLICATE_DEBTORS_FAIL:
      return Object.assign({}, state, {
        isDebtorMergeSaving: false,
      });
    case GET_DUPLICATE_DEBTORS_HISTORY:
      return Object.assign({}, state, {
        debtorHistory: {
          isLoading: true,
          data: [],
        },
      });
    case GET_DUPLICATE_DEBTORS_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        debtorHistory: {
          isLoading: false,
          data: getChildDebtorHistory(payload.data),
        },
      });
    case GET_DUPLICATE_DEBTORS_HISTORY_FAIL:
      return Object.assign({}, state, {
        debtorHistory: {
          isLoading: false,
          data: [],
        },
      });
    default:
      return state;
  }
};
